package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.components.forms.MonthDropdown
import io.horion.cv.components.forms.YearDropdown
import io.horion.cv.styles.PeriodeLabelStyle
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px

@Composable
fun PeriodeSelector(
    month: String,
    year: String,
    isOngoing: Boolean,
    onMonthChange: (String) -> Unit,
    onYearChange: (String) -> Unit,
    onOngoingChange: (Boolean) -> Unit,
    modifier: Modifier = Modifier,
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Column(
        modifier = modifier
            .fillMaxWidth()
            .minWidth(0.px)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .minWidth(0.px),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                text = "Période",
                modifier = PeriodeLabelStyle
                    .toModifier()
                    .color(
                        if (isDark) {
                            Colors.White
                        } else {
                            io.horion.cv.utils.Colors.Primary
                        }
                    )
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Light)
                    .then(
                        if (isOngoing) {
                            Modifier.opacity(0.4f)
                        } else {
                            Modifier
                        }
                    )
            )

            CheckboxWithLabel(
                checked = isOngoing,
                label = "En cours",
                onCheckedChange = onOngoingChange
            )
        }

        Box(
            modifier = Modifier.height(8.px)
        )

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .minWidth(0.px),
            horizontalArrangement = Arrangement.spacedBy(15.px)
        ) {
            MonthDropdown(
                selectedMonth = month,
                onMonthChange = onMonthChange,
                disabled = isOngoing,
                modifier = Modifier
                    .weight(1f)
                    .minWidth(0.px)
            )

            YearDropdown(
                selectedYear = year,
                onYearChange = onYearChange,
                disabled = isOngoing,
                modifier = Modifier
                    .weight(1f)
                    .minWidth(0.px)
            )
        }
    }
}